export enum ActionTypes {
 ASSIGN_TO_ME = '[ASSIGN_TO_ME] Assign to me',
 ASSIGN_TO_ME_SUCCESS = '[ASSIGN_TO_ME] Assign to me success',
 ASSIGN_TO_ME_FAILURE = '[ASSIGN_TO_ME] Assign to me failure',
}
